
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { read_message, readMessage } from '@/api/message';
import { AppModule } from '@/store/modules/app';
import { MessageModule, MessageUnreadStatus } from '@/store/modules/message';
import {
  formatApiError,
  stringFromIDate,
  formatTimeWithSecond,
} from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { UserModule } from '@/store/modules/user';
import { AppRoleType } from '@/utils/types';

@Component({
  name: 'MessageDetail',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private messageId?: string;
  private data = {} as read_message.Message;
  private loading = true;

  get canUnread() {
    return (
      UserModule.roles.some(r => (r as AppRoleType) !== AppRoleType.AGENT) &&
      this.data &&
      (this.data.type as read_message.Message.Type) ===
        read_message.Message.Type.RECEIVED
    );
  }

  mounted() {
    this.fetchData();
  }

  private async unread() {
    AppModule.StartProgress();
    try {
      const req = {
        id: this.messageId,
        asUnread: true,
      } as read_message.Request;
      const res = await readMessage(req);
      this.postReadMessage();
      AppModule.StopProgress();
      this.$router.push('/message/list');
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Unread message') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async fetchData() {
    this.loading = true;
    AppModule.StartProgress();
    try {
      const res = await readMessage({
        id: this.messageId,
      } as read_message.Request);
      this.data = res.message;
      this.postReadMessage();
      AppModule.StopProgress();
      this.loading = false;
    } catch (err) {
      AppModule.StopProgress();
      this.loading = false;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private postReadMessage() {
    MessageModule.SetMessageUnreadStatus(MessageUnreadStatus.LOADING);
  }

  private getSentAtText(sentAt: string) {
    return formatTimeWithSecond(new Date(sentAt));
  }

  private getReadAtText(readAt: string) {
    return formatTimeWithSecond(new Date(readAt));
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
